import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const LogOut = (props) => (
  <SvgIcon {...props} viewBox="0 0 27 27">
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line
        x1="13.0808"
        y1="0.0442047"
        x2="13.0808"
        y2="9.0442"
        stroke="currentColor"
      />
      <path
        d="M9.25385 3.79039C7.11293 4.66732 5.34231 6.25945 4.24367 8.2955C3.14503 10.3316 2.78636 12.6856 3.22877 14.9564C3.67117 17.2273 4.88728 19.2745 6.66988 20.7492C8.45248 22.224 10.6913 23.035 13.0048 23.0441C15.3183 23.0532 17.5635 22.2599 19.3576 20.7993C21.1518 19.3386 22.384 17.3011 22.8443 15.0338C23.3046 12.7664 22.9645 10.4097 21.882 8.36503C20.7994 6.32038 19.0414 4.71434 16.9075 3.82056"
        stroke="currentColor"
      />
    </svg>
  </SvgIcon>
);
export default LogOut;
